import { useState, useEffect } from 'react';

/**
 * Detecta se a tela é mobile (abaixo do breakpoint).
 * Atualiza reativamente ao redimensionar a janela.
 */
export function useMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint);
  useEffect(() => {
    const fn = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, [breakpoint]);
  return isMobile;
}
